export class MockJQueryThrottlingHandler {
    public static Instances: MockJQueryThrottlingHandler[] = [];
    public sendCount: number = 0;

    public send(): void {
        this.sendCount++;
    }

    constructor(
        public makeRequest: (activityId: string) => void,
        public requestThrottled?: (activityId: string, retryDelay: string, retryAttempt: number, retrying: boolean) => void) {
        MockJQueryThrottlingHandler.Instances.push(this);
    }

    public handleThrottleResponse: (jqXHR: JQuery.jqXHR<any>) => boolean = () => false;
}